import { Component } from 'san';
import { IShowInformationParams } from 'src/models';

export default class Information extends Component {
    _callback;

    constructor(options: any) {
        super(options);
    }

    initData(): {
        isShow: boolean;
        title: string;
        contents: string[];
    } {
        return {
            isShow: false,
            title: '',
            contents: []
        };
    }

    show(params: IShowInformationParams) {
        this.data.set('isShow', true);
        this.data.set('title', params.title);
        this.data.set('contents', params.contents);
        this._callback = params.callback;
    }

    submit() {
        this.cancel();
        if (this._callback) {
            this._callback();
        }
    }

    cancel() {
        // 取消时，不清空title、content等数据，而是在show()时重置数据。防止连续调用show()无效
        this.data.set('isShow', false);
    }
}